import { gql } from '@apollo/client';

export const USER_LOGS_QUERY = gql`
  query GetLogs($username: String) {
    getLogs(username: $username) {    
      username
      timestamp
      action
      parameters
      children {
        username
        timestamp
        action
        parameters
      }
    }
  }
`;

export const USER_FORM_DATA_QUERY = gql`
  query User($username: ID) {
    roles {
      label
      value
      canHaveMultipleHospitals
    }
    user(username: $username) {
      username
      fullName
      userPosition
      phoneNumber
      email
      proxyEmailAdmin
      professionalBoard
      boardRegistration
      roleOrchestra
      roleDiva
      userHospitals {
        label
        value
        pepId
        address
      }
      pepId
      isDisabled
    }
  }
`;
